import script from "./SeedItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SeedItem.vue?vue&type=script&setup=true&lang=js"

import "./SeedItem.vue?vue&type=style&index=0&id=0c678853&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c678853"]])

export default __exports__